import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

const RETRY_KEY = 'google_auth_retry'

export function AuthCallback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { handleCallback, login } = useAuth()
  const processedRef = useRef(false)

  useEffect(() => {
    if (processedRef.current) return
    processedRef.current = true

    const errorParam = searchParams.get('error_description') || searchParams.get('error')

    if (errorParam) {
      // Account linking: Cognito returns an error after the pre_sign_up
      // trigger links the Google identity. Auto-retry once — the second
      // attempt will succeed because the link is already established.
      if (errorParam.includes('ACCOUNT_LINKED')) {
        const hasRetried = sessionStorage.getItem(RETRY_KEY)
        if (!hasRetried) {
          sessionStorage.setItem(RETRY_KEY, 'true')
          login()
          return
        }
        // Already retried — fall through to error
        sessionStorage.removeItem(RETRY_KEY)
      }

      navigate('/login?error=callback_failed', { replace: true })
      return
    }

    // Exchange code for tokens (handleCallback reads code/state from URL)
    sessionStorage.removeItem(RETRY_KEY)
    handleCallback()
      .then(() => {
        navigate('/dashboard', { replace: true })
      })
      .catch(() => {
        navigate('/login?error=callback_failed', { replace: true })
      })
  }, [searchParams, handleCallback, login, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mb-4 text-lg font-medium">Processing authentication...</div>
        <div className="text-sm text-muted-foreground">Please wait while we log you in.</div>
      </div>
    </div>
  )
}
